import { z } from 'zod';

export const ReputationDismissFormSchema = z.object({
  dismissText: z.string().min(1, 'Required'),
});

export type ReputationDismiss = z.infer<typeof ReputationDismissFormSchema>;
